import { useEffect } from 'react'
import { Button, Card } from '@heroui/react'
import { useStationStore } from './store/stationStore'
import { useThemeStore } from './store/themeStore'
import { useErrorStore } from './store/errorStore'
import SimpleView from './components/SimpleView'

export default function App() {
  const initializeStations = useStationStore((s) => s.initializeStations)
  const refreshStations = useStationStore((s) => s.refreshStations)
  const canRefreshStations = useStationStore((s) => s.canRefresh)
  const initializeTheme = useThemeStore((s) => s.initializeTheme)
  const error = useErrorStore((s) => s.error)
  const clearError = useErrorStore((s) => s.clearError)

  useEffect(() => {
    initializeTheme()
  }, [initializeTheme])

  useEffect(() => {
    initializeStations()
  }, [initializeStations])

  // ҳ�����»�ý���/�Ӻ�̨�ָ�ʱ������ˢ�µ��������ݣ���̨ˢ�£�������û���
  useEffect(() => {
    const refreshIfNeeded = () => {
      if (document.visibilityState !== 'visible') return
      if (!canRefreshStations()) return
      void refreshStations(undefined, undefined, { showLoading: false })
    }

    window.addEventListener('focus', refreshIfNeeded)
    document.addEventListener('visibilitychange', refreshIfNeeded)
    return () => {
      window.removeEventListener('focus', refreshIfNeeded)
      document.removeEventListener('visibilitychange', refreshIfNeeded)
    }
  }, [canRefreshStations, refreshStations])

  return (
    <div className="app-root">
      <SimpleView />

      {error && (
        <div className="alert-overlay" role="alert" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 9999
        }}>
          <Card className="alert-card" style={{ padding: '20px', minWidth: '300px' }}>
            <div className="alert-header" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
              ��ʾ
            </div>
            <div className="alert-body">
              <div className="alert-text" style={{ marginBottom: '20px' }}>{error}</div>
              <div className="alert-actions" style={{ textAlign: 'right' }}>
                <Button onPress={clearError}>
                  ֪����
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  )
}
